function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import classnames from "classnames";
import { withNativeProps } from "../../utils/with-native-props";
var classPrefix = "tc-selector";
export var Pane = function Pane(props) {
  var panes = props.panes,
    selectorProps = props.selectorProps,
    activeKey = props.activeKey,
    setActiveKey = props.setActiveKey;
  var type = selectorProps.type,
    theme = selectorProps.theme;
  return panes.map(function (pane) {
    var _classnames;
    return withNativeProps(pane.props, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-tab-wrapper"),
      key: pane.key
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        var key = pane.key;
        if (pane.props.disabled) return;
        if (key === undefined || key === null) {
          return;
        }
        setActiveKey(key.toString());
      },
      className: classnames("".concat(classPrefix, "-tab"), "".concat(classPrefix, "-tab-").concat(type), "".concat(classPrefix, "-tab-").concat(theme), (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "-tab-active"), pane.key === activeKey), _defineProperty(_classnames, "".concat(classPrefix, "-tab-disabled"), pane.props.disabled), _classnames))
    }, /*#__PURE__*/React.createElement("span", null, " ", pane.props.title))));
  });
};